import { ICopyable } from '../controls/common/icopyable';
import { IEmailAttachment } from './interfaces/email-attachment.interface';

export class EmailAttachment implements ICopyable<IEmailAttachment> {
    id: number;
    name: string;
    size: number;
    fileName: string;

    public createCopy(): EmailAttachment {
        const instance = new EmailAttachment();
        instance.id = this.id;
        instance.name = this.name;
        instance.size = this.size;
        instance.fileName = this.fileName;

        return instance;
    }

    public static createFormCopy(emailTemplate: EmailAttachment): IEmailAttachment {
        const instance = new EmailAttachment();
        instance.id = emailTemplate.id;
        instance.name = emailTemplate.name;
        instance.size = emailTemplate.size;
        instance.fileName = emailTemplate.fileName;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.size = other.size;
        this.fileName = other.fileName;
    }

    /**
     * Retourne une instance de EmailAttachment à partir d'une instance de IEmailAttachment.
     * @param other : Instance de IEmailAttachment.
     * @returns : Instance de EmailAttachment.
     */
    public static from(other: IEmailAttachment) {
        if (!!other) {
            const instance = new EmailAttachment();

            instance.id = other.id;
            instance.name = other.name;
            instance.size = other.size;
            instance.fileName = other.fileName;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne un tableau d'instances de EmailAttachment à partir d'un tableau d'instances de IEmailAttachment.
     * @param other : Tableau d'instances de IEmailAttachment.
     * @returns : Tableau d'instances de EmailAttachment.
     */
    public static fromArray(others: IEmailAttachment[]) {
        if (!!others) {
            let attachments: EmailAttachment[] = [];

            others.forEach((x) => {
                const attachment = EmailAttachment.from(x);
                attachments.push(attachment);
            });

            return attachments;
        } else {
            return null;
        }
    }

    public getDisplayName() {
        return `${this.name} (id: ${this.id})`;
    }
}
